import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  defaultFullscreenPageStyling,
  pageWithBottomNavigationStyling,
} from "../../../../theme";
import BottomNavigation from "../../../Common/components/BottomNavigation";
import HealthRecordContainer from "../../components/HealthRecordContainer";
import HealthScoreHeader from "@/features/HealthScore/components/HealthScoreHeader";

export default function MyHealthRecordPage() {
  const { t } = useTranslation();

  return (
    <Stack>
      <HealthScoreHeader
        title={t("MyHealth.recordHeader.title")}
        description={t("MyHealth.recordHeader.description")}
      />
      <Stack
        sx={{
          ...defaultFullscreenPageStyling,
          ...pageWithBottomNavigationStyling,
        }}
      >
        <HealthRecordContainer />

        <BottomNavigation />
      </Stack>
    </Stack>
  );
}
